import classNames from 'classnames'
import styles from './index.module.scss'
import moment from 'moment';
import { Tooltip } from 'antd';

export const renderFunctions = {
  depositDocsTableRenderStatusColumn: (_, rowData) => {
    // const documentStatus = rowData.docProcessingStatus;

    // const classes = classNames({
    //   [styles.status_cercle]: true,
    //   [styles.status_cercle_green]: documentStatus === 'PROCESSED_IN_TIME',
    //   [styles.status_cercle_orange]: documentStatus === 'PROCESSED_APPROACHING_DEADLINE',
    //   [styles.status_cercle_red]: documentStatus === 'PROCESSED_IN_DEADLINE_EXCEEDED',
    //   [styles.status_cercle_green_half_empty]: documentStatus === 'NOT_PROCESSED_YET',
    //   [styles.status_cercle_orange_half_empty]: documentStatus === 'NOT_PROCESSED_APPROACHING_DEADLINE',
    //   [styles.status_cercle_red_half_empty]: documentStatus === 'NOT_PROCESSED_DEADLINE_EXCEEDED'
    // });

    // const classes = classNames({
    //   [styles.status_cercle]: true,
    //   [styles.status_cercle_green]: documentStatus === 'PROCESSED_IN_TIME',
    //   [styles.status_cercle_orange]: [
    //     'PROCESSED_APPROACHING_DEADLINE',
    //     'NOT_PROCESSED_YET',
    //     'NOT_PROCESSED_APPROACHING_DEADLINE',
    //   ].includes(documentStatus),
    //   [styles.status_cercle_red]: [
    //     'PROCESSED_IN_DEADLINE_EXCEEDED',
    //     'NOT_PROCESSED_DEADLINE_EXCEEDED',
    //   ].includes(documentStatus),
    // });

    const classes = classNames({
      [styles.status_cercle]: true,
      [styles.status_cercle_green]: rowData.colorStatus === 'green',
      [styles.status_cercle_red_full]: rowData.colorStatus === 'red-full',
      [styles.status_cercle_red]: rowData.colorStatus === 'red-circle',
      // [styles.status_cercle_red]: documentStatus === 'PROCESSED_IN_DEADLINE_EXCEEDED',
      [styles.status_cercle_orange]: rowData.colorStatus === 'orange',
      // [styles.status_cercle_orange]: documentStatus === 'NOT_PROCESSED_APPROACHING_DEADLINE',
      // [styles.status_cercle_red]: documentStatus === 'NOT_PROCESSED_DEADLINE_EXCEEDED'
    });

    const notProcessedYet = rowData.notProcessedYet;
    const processedInTime = rowData.processedInTime;
    // const processedApproachingDeadline = rowData.processedApproachingDeadline;
    const processedDeadlineExceeded = rowData.processedDeadlineExceeded;
    const notProcessedApproachingDeadline = rowData.notProcessedApproachingDeadline;
    const notProcessedDeadlineExceeded = rowData.notProcessedDeadlineExceeded;

    return (
      <Tooltip overlayInnerStyle={{ width: 'max-content' }} title={
        <ul style={{ fontSize: 14, width: 'max-content', paddingLeft: 14 }}>
          {/* Processed documents */}
          <li>Documents traités dans les délais: {processedInTime ?? 0}</li>
          {/* <li>Documents traités proche de l’échéance: {processedApproachingDeadline ?? 0}</li> */}
          <li>Documents traités après l’échéance: {processedDeadlineExceeded ?? 0}</li>

          {/* Not Processed documents */}
          <li>Documents pas encore traités: {notProcessedYet ?? 0}</li>
          <li>Documents non traités, échéance proche: {notProcessedApproachingDeadline ?? 0}</li>
          <li>Documents non traités, échéance dépassée: {notProcessedDeadlineExceeded ?? 0}</li>
        </ul>
      }>
        <span className={classes} />
      </Tooltip>
    )

    return (
      <span className={classes} />
    )
  },
  depositDocsTableRenderPercentageColumn: (value, rowData, more, a) => {
    // console.log({rowData, more, a, value})
    // const val = rowData.total
    // return <span>{value}%</span>
  },
  depositDocsTableRenderActionColumn: (value, rowData) => {
    // const depositDate = moment(rowData.depositDate);
    // const processingLimitDate = moment(rowData.processingLimitDate);
    // const lastModifiedDate = moment(rowData.lastModifiedDate);
    // const documentStatus = rowData.docStatus;
    // const isBeforeBy7Days = lastModifiedDate.clone().add(7, 'days').isSameOrBefore(processingLimitDate);
    // const isAfterLimitDate = lastModifiedDate.isAfter(processingLimitDate);
    let text = 'Aucne';

    const documentStatus = rowData.docProcessingStatus;

    if (
      documentStatus === 'PROCESSED_APPROACHING_DEADLINE' ||
      documentStatus === 'NOT_PROCESSED_APPROACHING_DEADLINE' ||
      documentStatus === 'NOT_PROCESSED_DEADLINE_EXCEEDED' ||
      documentStatus === 'NOT_PROCESSED_YET'
    ) {
      text = 'Rappel envoyé au responsable';
    }

    // if (isBeforeBy7Days && documentStatus === 'CONFIRMED') {
    //   text = 'Aucune';
    // }

    // if (isAfterLimitDate) {
    //   text = 'Priorité urgente: alerte au manager'
    // }
    return (
      <p>{text}</p>
    )
  },
  dateColumn: (value, rowData) => {
    if (!value) return <span>--</span>;
    return <span>{moment(value).format("DD/MM/YY")}</span>
  },
  depositDocsTableRenderPerClientStatusColumn: (_, rowData) => {
    const totalNonRespectedDeposits = rowData.totalNonRespectedDeposits;
    let isGreen = false;
    let isRed = false;

    if (totalNonRespectedDeposits > 0) {
      isRed = true;
    } else {
      isGreen = true;
    }

    const classes = classNames({
      [styles.status_cercle]: true,
      [styles.status_cercle_green]: isGreen,
      [styles.status_cercle_red]: isRed,
    });

    return (
      <span className={classes} />
    )
  },
  docsCountColumn: (_, rowData) => {
    return rowData?.docs?.length ?? 0;
  }
}
